"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Clipboard_1 = require("./Clipboard");
var useClipboard_1 = require("./useClipboard");
Object.defineProperty(exports, "useClipboard", { enumerable: true, get: function () { return useClipboard_1.useClipboard; } });
exports.default = Clipboard_1.Clipboard;
